/**
 * KvK-nummer normalisation — the frontend half of `nl.scrivio.shared.domain.KvkNumber`.
 *
 * A KvK-nummer identifies the onderneming at the Kamer van Koophandel. Scrivio stores one per
 * organisation and never refuses one: the column has no CHECK behind it and no `pattern` in
 * front of it, so what is stored is whatever a praktijkhouder typed.
 *
 * There is deliberately **no length rule**, which is the one way this differs from
 * {@link isValidAgbCode}. Eight digits is what a Dutch KvK-nummer looks like today, but nothing
 * in Scrivio refuses anything else, so a rule invented here would not make stored values
 * conform — it would only decide that some of them are not worth asking about.
 */
const NON_DIGITS = /[^0-9]/g

/**
 * The digits of `value`, or `null` when it is blank or holds no digits at all.
 *
 * `null` means "nothing to ask about", not "a value that matches nothing" — an
 * unnormalisable input is a question that was never put.
 */
export function normalizedKvkNumber(value: string | null | undefined): string | null {
  if (value == null) return null
  const digits = value.replace(NON_DIGITS, '')
  return digits === '' ? null : digits
}
